import {useQueryClient} from '@tanstack/react-query'
import {useEffect, useState} from 'react'

import {AutofillStatus} from '../consts'

import {useGetAutofillStatus} from './useGetAutofillStatus'

export const usePeriodicAutofillCheck = () => {
  const queryClient = useQueryClient()

  // useGetAutofillStatus has refresh period so there can be check
  const {data: autofillStatus} = useGetAutofillStatus()
  const [previousAutofillStatus, setPreviousAutofillStatus] =
    useState<typeof autofillStatus>(autofillStatus)
  // if autofill is finished then invalidate stockDevelopment query
  useEffect(() => {
    if (autofillStatus === previousAutofillStatus) {
      return
    }
    if (
      autofillStatus?.status === AutofillStatus.NotStarted &&
      previousAutofillStatus?.lastUpdatedAt !== autofillStatus.lastUpdatedAt
      // autofill finished
    ) {
      void queryClient.invalidateQueries({
        queryKey: ['stockDevelopment'],
        refetchType: 'all'
      })
      void queryClient.invalidateQueries({
        queryKey: ['schedule'],
        refetchType: 'all'
      })
    }
    if (autofillStatus !== previousAutofillStatus) {
      setPreviousAutofillStatus(autofillStatus)
    }
  }, [autofillStatus, previousAutofillStatus, queryClient])
}
